module.exports = __webpack_public_path__ + "static/media/19ESCAP1.797f9985.jpg";